/**
 * @fileoverview This file contains all the necessary scripts for the URL path 'phone/###'.
 * If a script is not used on these pages, please consider adding it to the correct file.
 */

import $ from "jquery";
import "jquery-validation";
import "jquery-mask-plugin";
import "jquery-smooth-scroll";

window.jQuery = $;
window.$ = $;

import * as commonJS from "./common.js";
import * as viewMore from "./area-codes/view-more.js";
import * as exchangesViewMore from "./area-codes/exchanges-view-more.js";
import * as carousel from "./area-codes/carousel.js";
import * as map from "./area-codes/map.js";
import * as barCharts from "./area-codes/bar-charts.js";
import * as lineCharts from "./area-codes/line-charts.js";
import * as demographicCharts from "./area-codes/demographic-charts.js";
import * as charts from "./charts.js";

// This export is important to ensure webpack detects the JS and does not skip it during cleaning
export {
  commonJS,
  viewMore,
  exchangesViewMore,
  carousel,
  map,
  barCharts,
  lineCharts,
  demographicCharts,
  charts,
};
